/* ═══════════════════════════════════════════════════════════════════════════
   Águas de Ipanema — CEP: uma digitação só, do produto até o checkout
   ═══════════════════════════════════════════════════════════════════════════
   O cálculo de frete continua sendo do app "Frete no Produto" — nada da
   integração dele é tocado aqui. Este arquivo cuida só das três coisas em
   volta:

     1. guardar o CEP que o cliente digitou;
     2. devolver esse CEP a qualquer calculadora que apareça depois;
     3. levar o CEP (e o endereço, quando conhecido) para o checkout.

   Fonte única da verdade: a chave aguas_shipping_postal_code. Nenhum
   componente guarda CEP próprio.

   Sobre o endereço: o serviço é o ViaCEP, que JÁ é usado em dois lugares do
   projeto — dentro do próprio app de frete e no snippet visionfrete.liquid.
   Reaproveitar evita dependência nova e um segundo terceiro recebendo dados.

   Nunca é gravado nada além do endereço logístico: sem nome, telefone, CPF,
   cartão. Número e complemento não são inventados — o ViaCEP não os fornece
   e nós não os deduzimos.
   ═══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  if (window.__aipCep) return;
  window.__aipCep = true;

  var CHAVE_CEP = 'aguas_shipping_postal_code';
  var CHAVE_END = 'aguas_shipping_address';

  /* Campos de CEP conhecidos: o do app (#zipcode/.input_cep) e o do snippet
     nativo do tema (#campo-cep), hoje desligado mas que passa a compartilhar
     a mesma chave se um dia for ligado. */
  var SELETORES = '#zipcode, .input_cep, #campo-cep';

  /* ── Formato ────────────────────────────────────────────────────────────── */
  function normalizar(v) { return String(v == null ? '' : v).replace(/\D/g, '').slice(0, 8); }
  function valido(cep)   { return /^[0-9]{8}$/.test(cep); }
  function formatar(cep) { return valido(cep) ? cep.slice(0, 5) + '-' + cep.slice(5) : cep; }

  /* ── Armazenamento ──────────────────────────────────────────────────────── */
  /* localStorage lança em aba anônima com dados de site bloqueados; nesse caso
     o site inteiro precisa seguir funcionando, só sem memória de CEP. */
  function ler(chave)          { try { return localStorage.getItem(chave); } catch (e) { return null; } }
  function gravar(chave, val)  { try { localStorage.setItem(chave, val); } catch (e) {} }
  function apagar(chave)       { try { localStorage.removeItem(chave); } catch (e) {} }

  function cepSalvo() {
    var c = normalizar(ler(CHAVE_CEP));
    return valido(c) ? c : '';
  }

  function enderecoSalvo() {
    try {
      var j = JSON.parse(ler(CHAVE_END) || 'null');
      return (j && valido(j.zip)) ? j : null;
    } catch (e) { return null; }
  }

  /* ── Endereço a partir do CEP (ViaCEP) ──────────────────────────────────── */
  function buscarEndereco(cep) {
    var atual = enderecoSalvo();
    if (atual && atual.zip === cep) return;      /* já resolvido, não repete */

    fetch('https://viacep.com.br/ws/' + cep + '/json/')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!d || d.erro) return;
        gravar(CHAVE_END, JSON.stringify({
          zip: cep,
          address1: d.logradouro || '',
          neighborhood: d.bairro || '',
          city: d.localidade || '',
          province: d.uf || '',
          country: 'Brazil'
        }));
      })
      .catch(function () { /* sem endereço: o checkout ainda recebe o CEP */ });
  }

  /* Grava o CEP. Trocar de CEP invalida o endereço antigo na mesma hora —
     senão o checkout receberia cidade de um CEP e zip de outro. */
  function salvar(bruto) {
    var cep = normalizar(bruto);
    if (!valido(cep)) return false;
    if (cepSalvo() !== cep) {
      gravar(CHAVE_CEP, cep);
      apagar(CHAVE_END);
      /* mensagem de frete grátis da sacola sonda de novo com o CEP novo */
      try { document.dispatchEvent(new CustomEvent('aip:cep', { detail: { cep: cep } })); } catch (e) {}
    }
    buscarEndereco(cep);
    return true;
  }

  /* ── Parâmetros de prefill do checkout ──────────────────────────────────── */
  /* Só entram campos que realmente sabemos. Sem CEP salvo, nada é anexado e a
     URL segue exatamente como o tema a montou. */
  function paramsCheckout() {
    var cep = cepSalvo();
    if (!cep) return null;

    var p = [['checkout[shipping_address][zip]', cep]];
    var e = enderecoSalvo();
    if (e && e.zip === cep) {
      if (e.address1) p.push(['checkout[shipping_address][address1]', e.address1]);
      if (e.city)     p.push(['checkout[shipping_address][city]', e.city]);
      if (e.province) p.push(['checkout[shipping_address][province]', e.province]);
      p.push(['checkout[shipping_address][country]', e.country || 'Brazil']);
    }
    return p;
  }

  /* Acrescenta os parâmetros a uma URL preservando tudo que já estava nela.
     O carrinho não é remontado em lugar nenhum: o mini-carrinho continua indo
     por GET /checkout e a página do carrinho continua fazendo POST /cart com
     o mesmo corpo — só o destino ganha query string. */
  function comParams(url) {
    var p = paramsCheckout();
    if (!p) return url;
    try {
      var u = new URL(url, window.location.origin);
      p.forEach(function (par) { u.searchParams.set(par[0], par[1]); });
      return u.toString();
    } catch (e) { return url; }
  }

  /* Links "FINALIZAR COMPRA" (mini-carrinho e carrinho vazio) */
  document.addEventListener('click', function (ev) {
    var a = ev.target && ev.target.closest ? ev.target.closest('a[href]') : null;
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (!/\/checkout(\/|\?|#|$)/.test(href)) return;
    a.setAttribute('href', comParams(a.href));
  }, true);

  /* Formulário do carrinho: POST /cart com <input name="checkout">.
     O corpo não é tocado — nem note, nem updates[], nem atributos. */
  document.addEventListener('submit', function (ev) {
    var f = ev.target;
    if (!f || f.tagName !== 'FORM') return;
    if (!f.querySelector('[name="checkout"]')) return;
    f.setAttribute('action', comParams(f.action));
  }, true);

  /* ── Campo de CEP: preencher, validar, guardar ──────────────────────────── */
  function caixaErro(campo, mostrar) {
    var linha = campo.closest('.container-btn') || campo.parentNode;
    if (!linha) return;
    var alvo = linha.parentNode;
    var msg = alvo && alvo.querySelector(':scope > .aip-cep-erro');
    if (mostrar) {
      if (!msg) {
        msg = document.createElement('div');
        msg.className = 'aip-cep-erro';
        msg.textContent = 'Digite um CEP válido.';
        alvo.insertBefore(msg, linha.nextSibling);
      }
    } else if (msg) {
      msg.remove();
    }
  }

  function ligarCampo(campo) {
    if (!campo || campo.dataset.aipCep === '1') return;
    campo.dataset.aipCep = '1';

    /* Devolve o CEP já conhecido. Só preenche campo vazio: se o cliente
       começou a digitar outro, o dele manda. Preencher não dispara o cálculo
       — quem decide calcular continua sendo o clique no botão. */
    var salvo = cepSalvo();
    if (salvo && !normalizar(campo.value)) {
      campo.value = formatar(salvo);
      campo.dispatchEvent(new Event('input', { bubbles: true }));
      campo.dispatchEvent(new Event('change', { bubbles: true }));
    }

    /* Máscara só quando o cursor está no fim — no meio do texto, reescrever o
       valor jogaria o cursor para a ponta a cada tecla. */
    campo.addEventListener('input', function () {
      var noFim = campo.selectionStart === campo.value.length;
      var d = normalizar(campo.value);
      if (noFim) campo.value = d.length > 5 ? d.slice(0, 5) + '-' + d.slice(5) : d;
      if (d.length === 8) { caixaErro(campo, false); salvar(d); }
    });

    campo.addEventListener('focus', function () { caixaErro(campo, false); });

    campo.addEventListener('blur', function () {
      var d = normalizar(campo.value);
      if (!d) { caixaErro(campo, false); return; }
      if (salvar(d)) { campo.value = formatar(d); caixaErro(campo, false); }
      else caixaErro(campo, true);
    });
  }

  /* Clique em CALCULAR: guarda antes do app calcular e sai da frente do erro
     dele — dois avisos de CEP inválido ao mesmo tempo seria ruído. */
  document.addEventListener('click', function (ev) {
    var b = ev.target && ev.target.closest ? ev.target.closest('.btnForm, .search_zipcode, .buscaCep') : null;
    if (!b) return;
    var campo = document.querySelector(SELETORES);
    if (!campo) return;
    caixaErro(campo, false);
    salvar(campo.value);
    if (valido(normalizar(campo.value))) marcarCarregando(b);
  }, true);

  /* Loading do botão. O app sinaliza o próprio estado ligando a classe
     "loading" em #calc-carrier; espelhamos isso no botão e desligamos quando
     ele apaga ou quando chega resultado. */
  function marcarCarregando(botao) {
    botao.classList.add('aip-carregando');
    var saida = document.querySelector('#calc-carrier');
    if (!saida) { setTimeout(function () { botao.classList.remove('aip-carregando'); }, 8000); return; }
    var obs = new MutationObserver(function () {
      if (!saida.classList.contains('loading')) {
        botao.classList.remove('aip-carregando');
        obs.disconnect();
      }
    });
    obs.observe(saida, { attributes: true, attributeFilter: ['class'], childList: true });
    setTimeout(function () { botao.classList.remove('aip-carregando'); obs.disconnect(); }, 15000);
  }

  /* ── Início ─────────────────────────────────────────────────────────────── */
  function varrer() { document.querySelectorAll(SELETORES).forEach(ligarCampo); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', varrer);
  } else { varrer(); }
  window.addEventListener('load', varrer);

  /* O bloco do app monta depois do HTML, e a gaveta do carrinho é
     re-renderizada a cada alteração — por isso a varredura fica de pé. Com
     debounce: sem ele, um observer de subtree inteira roda querySelectorAll a
     cada mutação da página. */
  var pendente = null;
  function varrerEmBreve() {
    if (pendente) return;
    pendente = setTimeout(function () { pendente = null; varrer(); }, 120);
  }
  new MutationObserver(varrerEmBreve).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', varrer);
})();
